/**
 * 品牌自定义设置
 */

const CONFIG = {
  // 马家私房面
  MJSFM: {
    'dish-menu.select-child-dish': '去定制',
  },
};

export default function getBrandConfig(brandType, key, defaultConfig) {
  const config = CONFIG[brandType];
  const result = config ? config[key] : '';

  return result || defaultConfig;
}



// WEBPACK FOOTER //
// ./src/helper/configs/brand.js